import styled from '@emotion/styled';
import SupplierRegistrationFormItemBox from '@supplierRegistration/components/SupplierRegistrationFormItemBox';

const HideableSupplierRegistrationFormItemBox = styled(SupplierRegistrationFormItemBox)<{ hidden: boolean }>`
  ${(p): string => (p.hidden ? 'display: none;' : '')}
`;

export default HideableSupplierRegistrationFormItemBox;
